import serverData from '../utils/server-data'
import { groupApi } from './groupApi'

export interface UploadPhotoPayload {
  filename: string
  file: string
}

export const uploadPhotoApiSlice = groupApi.injectEndpoints({
  endpoints: (builder) => ({
    uploadPhoto: builder.mutation<{ url: string }, UploadPhotoPayload>({
      query: (body) => ({
        url: `/media`,
        headers: { 'X-CSRF-Token': serverData._csrf },
        method: 'POST',
        body,
      }),
    }),
  }),
})

export const { useUploadPhotoMutation } = uploadPhotoApiSlice
